// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"0793123b","557":"8e3d09ed","631":"58cefc55"}[chunkId] + ".chunk.js";
};